import { memo } from "react";
const PlannedRouteMarker = ({color, size=24}) => {
  return (
    <svg
      width={size}
      height={size}
      viewBox={`0 0 ${size} ${size}`}
      fill="none"
      xmlns="http://www.w3.org/2000/svg"
    >
      <path
        d="M5 11.6095L7.53319 8.67724C8.26375 7.84877 9.52759 7.76939 10.3561 8.49994C10.569 8.68774 10.7396 8.91873 10.8563 9.17755L12.1904 12.1347L14.5101 10.6737C15.4447 10.085 16.6796 10.3655 17.2683 11.3001C17.3302 11.3984 17.3834 11.5019 17.4274 11.6095L19.184 15.7429"
        stroke={color}
        strokeWidth="2"
      />
    </svg>
  );
};

export default memo(PlannedRouteMarker);
